import g from "./useContract.js";
import "../../temp-lib/styles/theme.js";
import "@mui/material";
import { jsx as A } from "react/jsx-runtime";
import "../../temp-lib/legacy/header/Header.js";
import "../../temp-lib/legacy/infoAccordion/InfoAccordion.js";
import "../../temp-lib/legacy/layout/Layout.js";
import "../../temp-lib/legacy/nav/Nav.js";
import "@metamask/detect-provider";
import "../../temp-lib/legacy/util/provider/Web3Instance.js";
import { ERROR_CODE as M } from "../../temp-lib/constants/error.js";
import { CustomError as R } from "../../temp-lib/errors/customError.js";
import "jsonwebtoken";
import * as n from "ramda";
import "web3";
import "../../temp-lib/legacy/util/provider/WalletConnect.js";
import "../../download-lib/deserializes/yup/download.js";
import "../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import "../../temp-lib/components/account/adeptus/AdeptusSuccessPopup.js";
import "../../temp-lib/components/account/share/ConfirmButton.js";
import "../../temp-lib/components/account/share/FormControlledPassword.js";
import "i18next";
import { useCallback as c } from "react";
import "../../temp-lib/components/account/share/EmailOTPSender.js";
import "../../temp-lib/components/share/mui/Textfield.js";
import "react-hook-form";
import "../../temp-lib/components/account/share/ForgotPasswordButton.js";
import "../../temp-lib/components/account/share/PopupTitle.js";
import "../../temp-lib/components/account/share/SendEmailOTPButton.js";
import "../../temp-lib/components/footer/Footer.js";
import "../../temp-lib/components/role/EnoughRoleOnly.js";
import "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import "../../temp-lib/components/share/apeiron/ApeironButtonDisableTip.js";
import "../../temp-lib/components/share/apeiron/ApeironChickenPopup.js";
import "../../temp-lib/components/share/apeiron/ApeironCloseButton.js";
import "../../temp-lib/components/share/apeiron/ApeironCookieConsent.js";
import "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import "../../temp-lib/components/share/apeiron/ApeironGoToButton.js";
import "../../temp-lib/components/share/apeiron/ApeironImageButton.js";
import "../../temp-lib/components/share/apeiron/ApeironInfinityDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironReactPlayer.js";
import "../../temp-lib/components/share/apeiron/ApeironSectionTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTutorialDialog/ApeironTutorialDialog.js";
import "../../temp-lib/components/share/generic/CloseButton.js";
import "../../temp-lib/components/share/generic/IconText.js";
import "../../temp-lib/components/share/generic/ModalBox.js";
import "../../temp-lib/components/share/generic/Pagination.js";
import "../../temp-lib/components/share/generic/SearchEmptyState.js";
import "../../temp-lib/components/share/generic/Skeleton.js";
import "../../temp-lib/components/share/generic/TextInput.js";
import "next/script";
import "../../temp-lib/components/share/mui/Snackbar.js";
import "../../temp-lib/components/share/next/Image.js";
import "../../temp-lib/components/share/next/NextLink.js";
import "../../temp-lib/components/share/popup/InfoPopup.js";
import "../../temp-lib/constants/account.js";
import "../../temp-lib/constants/googleAnalytics.js";
import "../../temp-lib/constants/query.js";
import "../../temp-lib/contexts/account/AccountContext.js";
import "../../temp-lib/contexts/account/Geetest4Context.js";
import "../../temp-lib/contexts/adeptus/AdeptusContext.js";
import "@apollo/client";
import "@apollo/client/link/error";
import "@apollo/client/utilities";
import "../../temp-lib/contexts/config/ConfigContext.js";
import "../../temp-lib/contexts/language/LanguageContext.js";
import "../../temp-lib/util/i18n/helper/locale.js";
import "path";
import "query-string";
import "p-retry";
import "ramda-adjunct";
import "../../temp-lib/contexts/share/LogicControlContext.js";
import { useTranslation as _ } from "react-i18next";
import "../../temp-lib/contexts/fingerprint/FingerprintContext.js";
import "../../temp-lib/contexts/role/RoleContext.js";
import "../../temp-lib/contexts/share/DataGridContext.js";
import { useMessageContext as d } from "../../temp-lib/contexts/share/MessageContext.js";
import "../../temp-lib/contexts/share/PersistQueryContext.js";
import "../../temp-lib/contexts/share/PreloadContext.js";
import "@tanstack/react-query";
import "../../temp-lib/contexts/share/ScreenLogContext.js";
import "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "../../apostle-lib/deserializes/yup/apostle.js";
import "../../currency-lib/contexts/CurrencyContext.js";
import "../../temp-lib/contexts/web3/Web3Context.js";
import "../../wallet-lib/contexts/RoninNameServiceContext.js";
import "../../temp-lib/deserialize/yup/account.js";
import "../../temp-lib/deserialize/yup/chain.js";
import "../../temp-lib/deserialize/yup/locale.js";
import "../../temp-lib/deserialize/yup/page.js";
import "../../temp-lib/deserialize/yup/platform.js";
import "../../temp-lib/graphql/fragment/account.js";
import "date-fns";
import "date-fns/constants";
import "react-countdown";
import "next/router";
import "@walletconnect/utils";
import "@wagmi/core";
import "../../temp-lib/util/query/index.js";
import "../../temp-lib/deserialize/yup/adeptusCampaign.js";
import "../../temp-lib/graphql/query/getAdeptusCampaigns.js";
import "../../temp-lib/graphql/query/getPublicAccountDetail.js";
import "../../temp-lib/graphql/mutation/processEmailRegister.js";
import "../../currency-lib/constants/currency.js";
import "../../currency-lib/deserialize/yup/currency.js";
import "../../currency-lib/graphql/query/getCurrencyInfo.js";
import "../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import "../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import "../../temp-lib/util/erc20/index.js";
import "viem";
import "i18next-http-backend";
import "react-i18next/initReactI18next";
import "../../temp-lib/util/misc/formatNumberString.js";
import "../../temp-lib/util/yup/index.js";
import "../../temp-lib/wagmi/roninConnector.js";
import y from "../../ui-lib/components/ApeironPleaseWait.js";
const St = (h) => {
  const {
    contractTypes: l
  } = h, {
    setInfo: w
  } = d(), {
    t: p
  } = _(), e = g(l.allowance), {
    send: a
  } = g(l.request), i = c((o) => {
    n.isNotNil(o) && w({
      message: /* @__PURE__ */ A(y, {
        subject: o
      })
    });
  }, [w]), s = c(async (o, t, r) => {
    if (r) {
      const m = await e.call(o, t);
      return BigInt(m) >= r;
    } else
      return e.call(o, t);
  }, [e]), k = c(async (o, t, r, m = null, u = {
    checkMessage: p("common.check_token_approve"),
    waitMessage: p("common.wait_token_approve")
  }) => {
    const {
      checkMessage: C,
      waitMessage: N
    } = u;
    try {
      if (i(C), !await s(o, t, r))
        if (i(N), n.isNotNil(r)) {
          if (n.isNil(m))
            throw new R("please set allowance if you want to approve erc token", M.CONTRACT.APPROVAL_FAIL);
          await a(t, m.toString());
        } else
          await a(t, !0);
      return !0;
    } catch (f) {
      throw i(null), f;
    }
  }, [s, a, i, p]);
  return {
    checkAllowed: s,
    request: k
  };
};
export {
  St as default
};
//# sourceMappingURL=useAllowance.js.map
